export default __webpack_public_path__ + "static/media/product.03853d73.png";